import React from 'react';
import { CalendarCheck } from 'lucide-react';
import Reveal from '@/components/Reveal';
import CalendlyInline from '@/components/CalendlyInline';
import { CONTACT } from '@/data/contact';

export default function CalendlySection({
  dark = true,
  title = 'Prefer to speak with us directly?',
  body = 'Book a 30-minute call with a senior strategist. We will review your account, your offer and the fastest route to profitable scale.',
}) {
  return (
    <section
      id="book-a-call"
      className={`${dark ? 'bg-[#0B0B0B] border-t border-white/10' : 'bg-[#F5F5F5] border-t border-[#0B0B0B]/10'} py-20 lg:py-28`}
    >
      <div className="max-w-[1320px] mx-auto px-6 lg:px-10">
        <Reveal className="max-w-2xl mb-12">
          <span className="text-[11px] font-semibold uppercase tracking-[0.2em] text-[#3B82F6] block mb-4">
            Book an Appointment
          </span>
          <h2
            className={`font-display font-bold tracking-tight text-3xl lg:text-4xl leading-tight ${
              dark ? 'text-white' : 'text-[#0B0B0B]'
            }`}
          >
            {title}
          </h2>
          <p className={`mt-6 font-light leading-relaxed ${dark ? 'text-white/55' : 'text-[#0B0B0B]/60'}`}>{body}</p>
          <a
            href={CONTACT.calendly}
            target="_blank"
            rel="noopener noreferrer"
            className="group mt-8 inline-flex items-center gap-2.5 px-8 h-14 rounded-lg bg-[#2563EB] text-white text-sm font-bold hover:bg-[#1D4ED8] transition-colors"
          >
            <CalendarCheck className="w-4 h-4" /> Open the booking calendar
          </a>
        </Reveal>

        <Reveal delay={0.15}>
          <div
            className={`rounded-lg overflow-hidden border ${dark ? 'border-white/10 bg-[#0B0B0B]' : 'border-[#0B0B0B]/10 bg-white'} p-1 sm:p-2`}
          >
            <CalendlyInline
              className="w-full h-[820px] sm:h-[760px] lg:h-[700px]"
              url={
                dark
                  ? `${CONTACT.calendly}?hide_gdpr_banner=1&background_color=0b0b0b&text_color=ffffff&primary_color=2563eb`
                  : `${CONTACT.calendly}?hide_gdpr_banner=1&primary_color=2563eb`
              }
            />
          </div>
        </Reveal>
      </div>
    </section>
  );
}